<template>
    <td-dialog :title="$t(title)" :before-close="sysDialogClose" :visible.sync="dialogSysVisible" width="480px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formSysInfo" ref="formSysInfo" :rules="rules">
            <el-form-item :label="$t('common.SYSNAME')" :label-width="formLabelWidth" prop="name">
                <td-input v-model="formSysInfo.name" :maxlength="50"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.SYSFLG')" :label-width="formLabelWidth" prop="sysFlg">
                <td-input v-model="formSysInfo.sysFlg" :disabled="sysFlgReadonly" :maxlength="50"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.SYSURL')" :label-width="formLabelWidth" prop="url">
                <td-input v-model="formSysInfo.url" :maxlength="100"></td-input>
            </el-form-item>
            <el-row>
                <el-form-item :label="$t('common.MENU_URL')" :label-width="formLabelWidth" prop="menuUrl">
                    <el-col :span="18">
                        <td-input v-model="formSysInfo.menuUrl" :disabled="noCustomMenuUrl" :maxlength="50"></td-input>
                    </el-col>
                    <el-col :span="6">
                        <td-checkbox v-model="customMenuUrlFlg" @change="customMenuUrlChange">{{ $t('common.CUSTOM') }}</td-checkbox>
                    </el-col>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item :label="$t('common.DEPT_URL')" :label-width="formLabelWidth" prop="deptUrl">
                    <el-col :span="18">
                        <td-input v-model="formSysInfo.deptUrl" :maxlength="50"></td-input>
                    </el-col>
                    <!-- <el-col :span="6">
                        <td-checkbox v-model="customDeptUrlFlg" @change="customDeptUrlChange">{{ $t('common.CUSTOM') }}</td-checkbox>
                    </el-col> -->
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item :label="$t('common.DESCRIPTION')" :label-width="formLabelWidth" prop="description">
                    <td-input v-model="formSysInfo.description" type="textarea" :maxlength="100"></td-input>
                </el-form-item>
            </el-row>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm('formSysInfo')" :loading="loading">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="sysDialogClose">{{ $t('common.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import resourceApi from '../assets/api.js';
export default {
    props: ['title', 'dialogSysVisible', 'editItem', 'isAddData'],
    created() {
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.initEditData();
        } else {
            // sys类型默认选中第一个
            this.formSysInfo.iType = this.options[0].value;
        }
    },
    // 定义变量
    data() {
        let validateSysFlg = (rule, value, callback) => {
            if (!this.isAddData) {
                callback();
                return;
            }
            let param = {
                currentPage: 1,
                pageSize: 10,
                sysId: value
            };
            resourceApi.listSysInfo(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/auth/sys/listSysList', response.data.statusMessage);
                    return;
                }
                if (response.data.count > 0) {
                    callback(this.$t('error.ERROR_SYS_FLG_REPEAT'));
                } else {
                    callback();
                }
            });
        };
        return {
            // sys表单信息
            formSysInfo: {
                name: '',
                sysFlg: '',
                url: '',
                menuUrl: 'menuManager/listAllMenuInfo',
                deptUrl: '',
                description: ''
            },
            // sys类型数组
            options: [
                {
                    value: 0,
                    label: this.$t('common.RABBITMQ')
                }
            ],
            sysFlgReadonly: false,
            noCustomMenuUrl: true,
            customMenuUrlFlg: false,
            noCustomDeptUrl: true,
            customDeptUrlFlg: false,
            formLabelWidth: '30%',
            loading: false,
            // 对表单进行数据验证
            rules: {
                name: [
                    { required: true, message: this.$t('error.ERROR_SYS_CAPTION_NULL'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'blur' },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }
                ],
                sysFlg: [
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'blur' },
                    { required: true, message: this.$t('error.ERROR_SYSFLG_NULL'), trigger: 'blur' },
                    { validator: validateSysFlg, trigger: 'blur' },
                    { pattern: this.$regex.SYS_FLG, message: this.$t('error.ERROR_SYS_FLG_ILLEGAL') }
                ],
                url: [
                    { min: 1, max: 100, message: this.$t('error.ERROR_URL_MAX_LENGTH'), trigger: 'blur' },
                    { required: true, message: this.$t('error.ERROR_URL_NULL'), trigger: 'change' },
                    { pattern: this.$regex.URL_RULE_PRO, message: this.$t('error.ERROR_URL_ILLEGAL') }
                ],
                menuUrl: [
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'blur' },
                    { required: true, message: this.$t('error.ERROR_MENU_URL_NULL'), trigger: 'blur' },
                    { pattern: this.$regex.SUB_URL, message: this.$t('error.ERROR_MENU_URL_ILLEGAL') }
                ],
                deptUrl: [
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'blur' },
                    // { required: true, message: this.$t('error.ERROR_DEPT_URL_NULL'), trigger: 'blur' },
                    { pattern: this.$regex.SUB_URL, message: this.$t('error.ERROR_DEPT_URL_ILLEGAL') }
                ],
                description: [{ min: 0, max: 100, message: this.$t('error.ERROR_DESCRIPTION_MAX_LENGTH'), trigger: 'blur' }]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        // 更改目录菜单自定义状态
        customMenuUrlChange(value) {
            if (value) {
                this.noCustomMenuUrl = false;
            } else {
                this.noCustomMenuUrl = true;
                this.formSysInfo.menuUrl = 'menuManager/listAllMenuInfo';
            }
        },
        // 更改组织菜单自定义状态
        customDeptUrlChange(value) {
            if (value) {
                this.noCustomDeptUrl = false;
            } else {
                this.noCustomDeptUrl = true;
                // this.formSysInfo.deptUrl = '/org/query';
            }
        },
        // 初始化编辑数据
        initEditData() {
            this.formSysInfo.name = this.editItem.sName;
            this.formSysInfo.sysFlg = this.editItem.sSysFlg;
            this.formSysInfo.url = this.editItem.sUrl;
            this.formSysInfo.menuUrl = this.editItem.sMenuUrl;
            this.formSysInfo.deptUrl = this.editItem.sDeptUrl;
            this.formSysInfo.description = this.editItem.sDescription;
            this.sysFlgReadonly = true;
            if (this.formSysInfo.menuUrl == 'menuManager/listAllMenuInfo') {
                this.customMenuUrlFlg = false;
            } else {
                this.customMenuUrlFlg = true;
                this.noCustomMenuUrl = false;
            }
            // if (this.formSysInfo.deptUrl == '/org/query') {
            //     this.customDeptUrlFlg = false;
            // } else {
            //     this.customDeptUrlFlg = true;
            //     this.noCustomDeptUrl = false;
            // }
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loading = true;
                    let content = {
                        name: this.formSysInfo.name,
                        sysId: this.formSysInfo.sysFlg,
                        url: this.formSysInfo.url,
                        menuUrl: this.formSysInfo.menuUrl,
                        deptUrl: this.formSysInfo.deptUrl,
                        description: this.formSysInfo.description
                    };
                    if (this.isAddData) {
                        resourceApi.insertSysInfo(JSON.stringify(content), response => {
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('dialogSysinfo/insertSysInfo', response.data.statusMessage);
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('common.ADD_SUCCESS'), type: 'success' });
                            this.sysDialogClose();
                            /* 编辑或添加完成需调用查询接口 */
                            this.$emit('btnQuery');
                        });
                    } else {
                        content.id = this.editItem.sId;
                        resourceApi.updateSysInfo(JSON.stringify(content), response => {
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('dialogSysinfo/updateSysInfo', response.data.statusMessage);
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('common.MODIFY_SUCCESS'), type: 'success' });
                            this.sysDialogClose();
                            /* 编辑或添加完成需调用查询接口 */
                            this.$emit('btnQuery');
                        });
                    }
                }
            });
        },
        // 关闭窗口之前需要调用的方法
        sysDialogClose() {
            this.$emit('sysDialogClose');
            this.$refs['formSysInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
